import { Callout, Intent } from '@blueprintjs/core'
import { lang } from 'enablex/shared'
import cx from 'classnames'
import React, { FC } from 'react'

import logo from './media/enablexLogo.png'
import style from './style.scss'
import ChatBotIcon from '~/icons/ChatBotIcon'
import ChatIconLoginScreen from '~/icons/ChatIconLoginScreen'
import ChatIconBg from '~/icons/ChatIconBg'

interface Props {
  title?: string
  domainLogo?: string
  domainWorkspace?: string
  subtitle?: React.ReactNode
  error?: string | null
  poweredBy?: boolean
  children: React.ReactNode
}

const LoginContainer: FC<Props> = props => {
  const logoPath = props.domainLogo ? `/api/v1/bots/___/media/${props.domainWorkspace}/${props.domainLogo}` : logo
  return (
    <div className={cx('centered-container', style.centered_container)}>
      <div className={cx('middle', style.middle)}>
        <div className={cx('inner', style.inner)}>
          <img className={cx('logo', style.logo)} src={logoPath} alt="loading" />
          <div className={cx('card', 'card_body', style.card, style.card_body)}>
            <div className={cx('card_body', 'login_box', style.card_body, style.login_box)}>
              <div>
                <div className={cx('card_title', style.card_title)}>
                  <strong>{props.title || 'Enablex'}</strong>
                </div>

                <div className={cx('card_text', style.card_text)}>{props.subtitle || ''}</div>

                {props.error && <Callout intent={Intent.DANGER}>{props.error}</Callout>}
                {props.children}
              </div>
            </div>
          </div>
          {props.poweredBy && (
            <div className={cx('homepage', style.homepage)}>
              <p>
                {lang.tr('admin.poweredBy')} <a href="http://enablex.io/">EnableX</a>
              </p>
            </div>
          )}
        </div>
        <div className={style.marketingContent}>
          <ChatIconBg classProp={style.chat_icon_bg} />
          <ChatIconLoginScreen classProp={style.chat_icon_login} />
          <ChatBotIcon classProp={style.chat_bot_icon} />
          <p>
            <span className={style.qoute1}>Conversations, Solutions, and Endless Possibilities</span>
            <br />
            <span className={style.qoute2}>{'-'} chat with the future today!</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoginContainer
